// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__-OfLm","signatureButtonsRight":"ModalSign_signatureButtonsRight__2lS1l"};